import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Container } from '../../../../primitives/Select/components/Control/components/Container.js';
import { Icon } from '../../../../primitives/Select/components/Control/components/Icon.js';
export const Control = props => {
  const {
    children,
    isDisabled,
    hasValue,
    selectProps,
    getStyles,
    isFocused,
    innerRef,
    innerProps
  } = props;
  const {
    controlIcon,
    size
  } = selectProps;
  return _jsxs(Container, {
    ref: innerRef,
    reactSelectStyles: getStyles('control', props),
    isFocused: isFocused,
    isDisabled: isDisabled,
    hasValue: hasValue,
    size: size,
    invalid: selectProps.invalid,
    centered: selectProps.centered === true,
    ...innerProps,
    children: [controlIcon && _jsx(Icon, {
      children: controlIcon
    }), children]
  });
};